import { useLocation } from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';

import { EVOLUTION_APP_TYPE, EVOLUTION_EVENTS } from '../constants';

export const useTableIdChangeHandler = () => {
    const { search } = useLocation();
    const [tableId, setTableId] = useState(null);
    const messageHandler = useCallback((message) => {
        if (EVOLUTION_EVENTS.APPLICATION_READY !== message?.data?.event) {
            return;
        }

        if (EVOLUTION_APP_TYPE.GAME !== message?.data?.applicationType) {
            return;
        }

        if (tableId !== message?.data?.tableId) {
            if (tableId) {
                const params = new URLSearchParams(search);

                params.set('integrationType', message?.data?.tableId);

                // force page reload
                window.location.search = params.toString();
            }

            setTableId(message?.data?.tableId);
        }
    }, [
        tableId,
        search
    ]);

    useEffect(() => {
        window.addEventListener('message', messageHandler);

        return () => {
            window.removeEventListener('message', messageHandler);
        };
    });
};
